import React from 'react';
import { Link } from 'react-router-dom';
import './TechnologyServices.css';

const TechnologyServices = () => {
  return (
    <div className="tech-services-page">
      <section className="tech-hero">
        <div className="tech-hero-container">
          <div className="tech-hero-content">
            <h1 className="tech-hero-title">Business Technology Services</h1>
            <p className="tech-hero-description">
              Secure foundation for networks, devices, security, and support. Resilient infrastructure with security built in, not bolted on. Fewer headaches, better uptime, one accountable partner.
            </p>
            <Link to="/contact" className="btn-tech-hero">Speak to an Expert</Link>
          </div>
          <div className="tech-hero-image">
            <img 
              src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80" 
              alt="Technology Infrastructure" 
            />
          </div>
        </div>
      </section>

      <section className="tech-services-section">
        <div className="tech-container">
          <h2 className="tech-section-title">Our Technology Services</h2>
          
          <div className="tech-services-grid">
            <div className="tech-service-card">
              <img 
                src="https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=400&q=80" 
                alt="Network Infrastructure"
                className="tech-card-image"
              />
              <div className="tech-card-content">
                <h3 className="tech-card-title">Network Infrastructure</h3>
                <p className="tech-card-description">
                  Design, implementation, and management of enterprise-grade networks. We build resilient, 
                  scalable network infrastructure that supports your business growth.
                </p>
                <Link to="/contact" className="tech-card-link">Learn More →</Link>
              </div>
            </div>

            <div className="tech-service-card">
              <img 
                src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400&q=80" 
                alt="Cybersecurity"
                className="tech-card-image"
              />
              <div className="tech-card-content">
                <h3 className="tech-card-title">Cybersecurity</h3>
                <p className="tech-card-description">
                  Comprehensive security solutions to protect your business from evolving threats. 
                  Security built in, not bolted on. Layered security approaches that protect your data and systems.
                </p>
                <Link to="/contact" className="tech-card-link">Learn More →</Link>
              </div>
            </div>

            <div className="tech-service-card">
              <img 
                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&q=80" 
                alt="Infrastructure Management"
                className="tech-card-image"
              />
              <div className="tech-card-content">
                <h3 className="tech-card-title">Infrastructure Management</h3>
                <p className="tech-card-description">
                  Proactive management and maintenance of your technology infrastructure. We monitor, maintain, 
                  and optimize your systems 24/7 so you can focus on your business.
                </p>
                <Link to="/contact" className="tech-card-link">Learn More →</Link>
              </div>
            </div>

            <div className="tech-service-card">
              <img 
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80" 
                alt="Device Management"
                className="tech-card-image"
              />
              <div className="tech-card-content">
                <h3 className="tech-card-title">Device Management</h3>
                <p className="tech-card-description">
                  End-to-end management of workstations, mobile devices, and peripherals to keep your 
                  team productive and secure. Complete device lifecycle management.
                </p>
                <Link to="/contact" className="tech-card-link">Learn More →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tech-cta-section">
        <div className="tech-cta-container">
          <h2 className="tech-cta-title">Ready to Build a Secure Technology Foundation?</h2>
          <p className="tech-cta-description">
            Let's discuss how our technology services can support your business goals.
          </p>
          <Link to="/contact" className="btn-tech-primary">Speak to an Expert</Link>
        </div>
      </section>
    </div>
  );
};

export default TechnologyServices;
